var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-records" },
    _vm._l(_vm.records, function (record) {
      return _c(
        "div",
        {
          key: record._id,
          staticClass: "table-row",
          class: {
            selected: _vm.isSelectionModeActive && _vm.isSelected(record._id),
          },
          attrs: { id: "record-" + record._id, "data-record-id": record._id },
          on: {
            mouseover: function ($event) {
              !_vm.isSelectionModeActive && _vm.showCheckbox(record._id)
            },
            mouseleave: function ($event) {
              !_vm.isSelectionModeActive && _vm.hideCheckbox(record._id)
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "table-cell record-id-cell" },
            [
              !_vm.isSelectionModeActive && !_vm.isCheckboxVisible(record._id)
                ? _c("span", [_vm._v(_vm._s(record.recordId))])
                : _c("a-checkbox", {
                    attrs: { checked: _vm.isSelected(record._id) },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("toggle-selection", record._id)
                      },
                    },
                  }),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.visibleFields, function (field, index) {
            return _c(
              "div",
              {
                key: field._id,
                staticClass: "table-cell",
                class: { active: _vm.isActiveCell(record._id, field._id) },
                attrs: { tabindex: "0", "data-field-type": field.fieldType },
                on: {
                  click: function ($event) {
                    return _vm.setActiveCell(record._id, field._id)
                  },
                  keydown: [
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                      ) {
                        return null
                      }
                      if (
                        $event.ctrlKey ||
                        $event.shiftKey ||
                        $event.altKey ||
                        $event.metaKey
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.moveToNextCell(record._id, index)
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      if (
                        $event.ctrlKey ||
                        $event.shiftKey ||
                        $event.altKey ||
                        $event.metaKey
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.editCell(record._id, field._id)
                    },
                  ],
                },
              },
              [
                ["text", "long-text", "email", "url", "phone"].includes(
                  field.fieldType
                )
                  ? _c("StringCell", {
                      ref: "stringCells",
                      refInFor: true,
                      attrs: { record: record, field: field },
                      on: {
                        "update-record": function ($event) {
                          return _vm.updateRecord($event)
                        },
                      },
                    })
                  : field.fieldType === "checkbox"
                  ? _c("CheckboxCell", {
                      attrs: { record: record, field: field },
                      on: {
                        "update-record": function ($event) {
                          return _vm.updateRecord($event)
                        },
                      },
                    })
                  : field.fieldType === "number"
                  ? _c("NumberCell", {
                      attrs: { record: record, field: field },
                      on: {
                        "update-record": function ($event) {
                          return _vm.updateRecord($event)
                        },
                      },
                    })
                  : field.fieldType === "currency"
                  ? _c("CurrencyCell", {
                      attrs: { record: record, field: field },
                      on: {
                        "update-record": function ($event) {
                          return _vm.updateRecord($event)
                        },
                      },
                    })
                  : field.fieldType === "dropdown"
                  ? _c("DropdownCell", {
                      attrs: { record: record, field: field },
                      on: {
                        "update-record": function ($event) {
                          return _vm.updateRecord($event)
                        },
                      },
                    })
                  : field.fieldType === "datetime"
                  ? _c("DateCell", {
                      attrs: { record: record, field: field },
                      on: {
                        "update-record": function ($event) {
                          return _vm.updateRecord($event)
                        },
                      },
                    })
                  : field.fieldType === "automation-button"
                  ? _c("ButtonCell", {
                      attrs: {
                        record: record,
                        field: field,
                        tableId: _vm.table._id,
                      },
                      on: {
                        "update-record": function ($event) {
                          return _vm.updateRecord($event)
                        },
                      },
                    })
                  : _c("div", { staticClass: "table-cell-inner" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.getFieldValue(record, field._id)) +
                          "\n            "
                      ),
                    ]),
              ],
              1
            )
          }),
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }